import { observable } from "mobx";
import { Type } from "class-transformer";
import type ExemptionResponse from "./exemptionResponse";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export class ExemptionCancellationRequest {
  /**
   * Cancellation record ID.
   */
  @observable
  cancellationRecordId!: string;

  /**
   * Cancellation reason.
   */
  @observable
  cancellationReason?: string;

  /**
   * If true, exemption should be canceled immediately.
   */
  @observable
  isImmediateCancellation?: boolean;

  /**
   * If specified, exemption is valid until this date (last second of the date).
   */
  @observable
  @Type(() => Date)
  validUntilDate?: Date;

  @observable
  @Type(() => Date)
  _validSinceDate?: Date;
}

export default class ExemptionCancellation extends ExemptionCancellationRequest {
  constructor(exemption: ExemptionResponse) {
    super();
    this._validSinceDate = exemption.validSince;
  }
}

export const CancelExemptionValidationRules: EntityValidationRules<ExemptionCancellationRequest> = {
  validUntilDate: {
    required: true,
    isAfter: {
      condition: (entity: ExemptionCancellationRequest) => entity._validSinceDate,
    },
  },
  cancellationRecordId: {
    required: true,
    isLength: {
      max: 50,
    },
  },
  cancellationReason: {
    isLength: {
      optional: true,
      max: 160,
    },
  },
};
